import * as SimpleMDE from 'simplemde';
import { EmojiDefinition } from './emoji-provider.service';

declare const $: any;

export class EmojiPickerService {
    static $inject = ['$compile', '$rootScope', '$http', 'CacheService'];

    /**
     * Callback for destroying the current instance of emoji picker.
     * @private
     */
    private destroy?: () => any;

    constructor(private $compile: ng.ICompileService, private $rootScope: ng.IRootScopeService) {}

    /**
     * Create a toolbar icon. To be used with SimpleMDE `toolbar` parameter.
     * This will open emoji-picker component and handle adding new emojis into the SimpleMDE editor.
     *
     * @param $element Pass parent element, so we can render picker in the right place.
     *                 There can be multiple editors on page.
     */
    createToolbarIcon($element: JQLite) {
        return {
            name: 'emoji-picker',
            action: (simplemde: SimpleMDE) => {
                // destroy the current instance if exists
                if (this.destroy) {
                    this.destroy();
                    return;
                }

                type PickerScope = {
                    coordinates: { top: string; left: string };
                    onEmojiSelected: (emoji: EmojiDefinition) => any;
                } & ng.IScope;

                const emojiPickerScope: PickerScope = this.$rootScope.$new() as PickerScope;

                // get toolbar icon dom element in the SimpleMDE toolbar
                const target = $element.find('.editor-toolbar a.fa.fa-smile').get(0);

                if (!target) {
                    console.warn('Cannot create emoji picker toolbar button. Toolbar element not found.');
                    return;
                }

                // get the icon position
                const position = this.getCoords(target);

                // cordinates used to position the emoji picker above toolbar emoji icon
                emojiPickerScope.coordinates = {
                    top: `${position.top}px`,
                    // if position is offscreen - move the container to the right + add 40px margin
                    left: `${position.left < 400 ? 440 : position.left}px`,
                };

                // handle emoji selected
                emojiPickerScope.onEmojiSelected = (emoji: EmojiDefinition) => {
                    const pos = simplemde.codemirror.getCursor();
                    simplemde.codemirror.setSelection(pos, pos);
                    simplemde.codemirror.replaceSelection(emoji.emoji);

                    destroy();
                };

                const domElement = this.$compile(
                    '<ty-emoji-picker coordinates="coordinates" on-emoji-selected="onEmojiSelected($value)"/>'
                )(emojiPickerScope)[0];

                emojiPickerScope.$digest();

                // close the picker when a click occurs outside of the picker
                const mousedownListener = (e: MouseEvent) => {
                    // check if click occured inside the emoji picker
                    if ($(e.target).parents('ty-emoji-picker').length) {
                        return;
                    }
                    // for all clicks that are outside the emoji picker - destroy the picker
                    this.destroy && this.destroy();
                };
                document.body.addEventListener('mousedown', mousedownListener);

                // create destroy callback for current emoji picker instance
                const destroy = () => {
                    emojiPickerScope.$destroy();
                    domElement.remove();
                    this.destroy = undefined;
                    document.body.removeEventListener('mousedown', mousedownListener);
                };

                this.destroy = destroy;

                // append the emoji picker component to body
                document.body.append(domElement);
            },
            className: 'fa fa-smile',
            title: 'Emoji',
        };
    }

    private getCoords(elem: Element): DOMRect {
        return elem.getBoundingClientRect();
    }
}

angular.module('tradersyard').service('EmojiPickerService', EmojiPickerService);
